export const GITHUB_MCP_VALUE_SUMMARY =
    'Connect GitHub so the agent can read the code behind your metrics.';
export const GITHUB_MCP_SUGGESTED_PROMPT =
    'Trace one of my metrics back to the code that produces it';
export const GITHUB_MCP_CONNECTED_HEADLINE = 'GitHub connected';
export const GITHUB_MCP_CONNECTED_SUMMARY =
    'Ask the agent about the code behind a metric or event.';
